import * as z from 'zod/v4';

export const SupportedInputType = {
    Text: 'text',
    Long: 'long',
    Select: 'select',
    Checkbox: 'checkbox',
    Date: 'date',
    Time: 'time',
    File: 'file',
    Color: 'color',
    Rating: 'rating',
} as const;
export const SupportedInputTypeEnum = z.enum(SupportedInputType);
export type SupportedInputTypeE = z.infer<typeof SupportedInputTypeEnum>;

export const ExitQuestionSchema = z.object({
    label: z.string(),
    key: z.string().or(z.number()).prefault(Date.now()),
    secondaryLabel: z.string().optional(),
    options: z.array(z.string()).optional(),
    restrict: z.boolean().prefault(false),
    qType: SupportedInputTypeEnum.prefault('text'),
    value: z.string().optional()
});
export type ExitQuestion = z.infer<typeof ExitQuestionSchema>;

export const TestMetaProfileSchema = z.object({
    showProfileCard: z.boolean().prefault(true),
    showExitQuestions: z.boolean().prefault(true),
    questionSet: z.string().prefault('realestate'),
    allNonTestQuestionsToEnd: z.boolean().prefault(false),
    exitQuestions: z.array(ExitQuestionSchema).prefault([
        {label: 'Preferred Contact', key: '1000', qType: 'select', options: ['from: Email, Phone, Text']},
        {label: 'Do you rent or own?', key: '1001', qType: 'select', options: ['from: Rent, Own, Other']},
        {label: 'Payment Amount', key: '1003', qType: 'text'},
        {label: 'Must sell or complete a lease', key: '1002', qType: 'checkbox'},
        {label: 'How many more payments?', key: '1005', qType: 'text'},
        {label: 'Purchasing with a partner', key: '1006', qType: 'checkbox'},
    ])
});
export type TestMetaProfile = z.infer<typeof TestMetaProfileSchema>;
